import Eleicaonet from "@/services/eleicaonet";
import Subscription from "@/services/subscription";

export default {
  Eleicaonet,
  Subscription,
};
